import React from "react";
import { User } from "../../core";
import BlankProPic from "../../styles/images/no-user-sm.png";
interface UserImageProps {
  user: User & { primaryEmail?: string; primaryPhone?: string };
  showInfo?: boolean;
}

export const UserImage: React.FC<UserImageProps> = (props: UserImageProps) => {
  const { user, showInfo } = props;
  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={user?.avatar?.location ? user?.avatar?.location : BlankProPic}
        alt={user?.name}
        width={30}
        height={30}
        style={{
          marginRight: 10,
          borderRadius: "50%",
          border: "1px solid grey",
        }}
      />
      <div className="d-flex flex-column ">
        <div>
          {user?.name ||
            user?.firstLastName ||
            user?.fullName ||
            user?.firstName ||
            user?.contactName}
        </div>
        {showInfo && (
          <div className="d-flex align-items-center font-xs">
            <span>{user?.primaryEmail}</span>
            {!!user?.primaryEmail && !!user?.primaryPhone && (
              <div className="text-muted d-flex align-items-center pt-1  mx-1">•</div>
            )}
            <span>{user?.primaryPhone}</span>
          </div>
        )}
      </div>
    </span>
  );
};
